/* eslint-disable max-len */
/* eslint-disable max-len */

export default {
  lang: 'French',
  homeScreen: {
    title: 'Remarquablement rare', // Product specific
    stayConnected: 'Rester Connecté(e):',
    comingSoon: 'À venir',
    messages: 'Messages',
  },
  loginScreen: {
    forgot: 'Réinitialiser le mot de passe',
    title: 'Programme de formation professionnelle en voyage et de promotion des ventes',
    welcome: {
      headerTop: 'Bienvenue au',
      headerBottom: 'spécialistes du Canada', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Apprendre, promouvoir et vendre en déplacement',
      1: 'Formation multimédia sur tous les appareils',
      2: "Certificat d'achèvement",
      3: "Présentations commerciales prêtes à l'emploi",
      4: 'Matériel promotionnel à fort impact',
      5: "Conseils d'initiés et promotions",
      6: 'Répertoire des produits en temps réel',
      7: 'Nouvelles et mises à jour en temps opportun',
    },
    emailPrompt: 'Veuillez entrer votre adresse email pour confirmer que vous êtes un professionnel du voyage.',
    tAndC: {
      agree: 'En continuant, vous acceptez notre',
      privacyPolicy: ' politique de confidentialité',
      and: ' et ',
      termsConditions: 'nos termes et conditions',
    },
    version2: {
      homeTitle: 'Voyons si nous pouvons trouver un profil existant pour vous dans notre système.',
      homeTitleSub:
        "Saisissez l'adresse électronique que vous utilisez habituellement pour vous connecter aux programmes de formation.",
      noAccount:
        "Aucun compte n'a été trouvé ({email}), veuillez essayer avec un autre email ou créer un compte maintenant.",
      continueButton: 'Continuer',
      success:
        "La mise à jour de votre compte a été effectuée avec succès ! Vous serez bientôt redirigé vers la page d'accueil.",
      successNewAccount:
        'Pour compléter votre inscription, vous recevrez un courriel de confirmation pour vérifier votre compte.',
      loginButton: 'Connexion',
      matchFound: 'Nous avons trouvé une correspondance, veuillez saisir votre mot de passe pour continuer.',
      magicLink: "Connectez-vous à l'aide d'un lien figurant dans votre courrier électronique :",
      magicLinkButton: 'Demande de lien magique',
      magicLinkTitle: 'Un lien direct vous est envoyé par e-mail pour vous permettre de vous inscrire instantanément.',
      otherEmailButton: 'Soumettre',
      title:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      titleIndustry:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      register: 'Créer un compte',
      agent: 'Conseiller en voyages',
      visitor: "Visiteur de l'industrie",
      step1: "Étape 1 : Type d'utilisateur",
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      milesAttack: 'Avec vous un code Miles Attack ? Indiquez les 4 lettres',
      marketingOptIn: "Êtes-vous sûr de ne pas vouloir rester en contact avec l'équipe commerciale de ce programme ?",
      optIn: 'Oui, je suis intéressé',
      optOut: 'Pas intéressé',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      privacyHead: 'LES PRÉFÉRENCES EN MATIÈRE DE COMMUNICATION',
      privacySub:
        "Cochez les cases ci-dessous pour vous assurer de recevoir les communications importantes de l'équipe commerciale du fournisseur (mises à jour et annonces de produits, récompenses, incitations, FAM, etc.) et les initiatives de TravPRO Mobile en matière de réseautage et d'aide à la vente pour les professionnels du voyage.",
      privacy:
        "Nous protégeons votre vie privée et ne vendons pas, n'utilisons pas à mauvais escient et ne trahissons pas votre confiance.",
      store: "Téléchargez facilement ce programme dans votre magasin d'applications :",
      powered: 'ALIMENTÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous vous avons envoyé par e-mail le lien de réinitialisation de votre mot de passe ! Vous serez redirigé vers la page de connexion dans 10 secondes.',
        emailNotExisting: "L'adresse électronique que vous avez saisie n'existe pas.",
        magicLinkMessage: 'Veuillez patienter, nous sommes en train de vous inscrire.',
        magicLinkError:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkError1:
          "Nous n'avons pas trouvé de jeton valide, veuillez vous connecter ou demander un nouveau lien magique. Si le problème persiste, veuillez nous contacter à l'adresse suivante : info@travpromobile.com.",
        magicLinkError2:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkSuccess:
          "Consultez votre courrier électronique à l'adresse {email}. Il contient un lien magique qui vous permettra de vous connecter.",
        magicLinkErrorWait: 'Veuillez attendre 5 minutes entre les demandes de liens magiques.',
        emailNotFoundError:
          "L'adresse électronique que vous avez saisie ne figure pas dans nos dossiers. Veuillez vérifier les fautes d'orthographe ou créer un compte.",
      },
      errors: {
        zipCodeNotFound: 'Code postal non trouvé, réessayez',
        zipCodeOnlyNumbers: 'ZipCode ne peut contenir que des chiffres',
        password: 'Veuillez saisir un mot de passe',
        passwordNotMatching: 'Les mots de passe saisis ne correspondent pas',
        passwordTooShort: 'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          "Cette adresse électronique existe déjà ou n'est pas valide. Veuillez essayer avec une autre adresse électronique ou vous connecter à votre compte.",
        fillInAllFields: 'Veuillez remplir tous les champs obligatoires',
        fillInEmail: 'Veuillez indiquer votre adresse électronique.',
        emailNotExisting: "L'adresse électronique que vous avez saisie n'existe pas.",
      },
      fields: {
        forgotSubCopy: 'Vous avez oublié votre mot de passe et souhaitez le modifier ? ',
        forgotSubCopy2:
          'Vous voulez éviter le mot de passe ? Nous vous enverrons un e-mail contenant un lien magique qui vous permettra de vous connecter automatiquement au programme.',
        city: 'Ville',
        companyName: "Nom de l'entreprise",
        role: 'Votre rôle',
        description: "Laquelle décrit le mieux l'activité de votre entreprise ?",
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisissez un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: "Nom de l'agence",
        title: 'Votre rôle (Sélectionnez un rôle)',
        company: "Nom de l'entreprise",
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate: 'Quel est le groupe auquel vous êtes PRINCIPALEMENT affilié ?',
        hostAgency: "Votre agence d'accueil ?",
        executive: 'Cadre',
        management: 'Gestion',
        marketing: 'Marketing',
        sales: 'Vente',
        coordinator: 'Coordinateur',
        opt: "Restez en contact avec l'équipe commerciale de ce programme et recevez des mises à jou",
        optMarketing: 'Restez en contact avec TravPRO en ce qui concerne les programmes et événements similaires.',
        retail: "Façade d'un magasin de détail",
        home: 'Agent à domicile',
        independent: 'Entrepreneur indépendant',
        host: "Agence d'accueil",
        call: "Centre d'appel ou agence en ligne",
        other: 'Autres',
        describes: "Qu'est-ce qui décrit le mieux votre activité et celle de votre agence ?",
        milesAttack: 'Code Miles Attack (facultatif)',
      },
    },
    fields: {
      select: 'Sélectionnez une option ci-dessous',
      country: 'Pays',
      forgotCopylong:
        'Vous avez oublié votre mot de passe ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
      forgot:
        '« Mot de passe oublié ? » Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe',
      agency: 'Agence',
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      agencyName: "Nom de l'agence",
      stateProvince: 'État / Province',
      registrationCode: 'Code Promo (Optionnelle)',
      required: 'Obligatoire',
      invalidEmail: 'Adresse email invalide',
      opt: 'Reste en contact! Oui, j’aimerais opter pour les communications de Destination Canada qui me tiendront au courant des actualités, des événements, des incitations, des visites familiales et plus encore!',
    },
    noAgent: {
      noAgentButton: 'Je ne suis pas un conseiller',
      title: 'Merci de votre intérêt pour Canada ',
      messageWeb: 'Le contenu de ce site est exclusivement reservé aux professionnels du voyage.',
      messageMobile:
        "Une partie du contenu de cette application est exclusivement reservé aux professionnels du voyage, mais n'hésitez pas à naviguer un aperçu de ce que cette application peut offrir en appuyant sur « Continuer ». ",
      continue: 'Continuez',
      visitWebsite: 'Visiter le site web >',
    },
    newUser: 'Nouvel utilisateur',
    register: 'Enregistrer',
  },
  welcomeScreen: {
    title: 'Bienvenue au\nProgramme de formation et compagnon de ventes au spécialistes du Canada \n',
    helloUser: 'Salut',
    hello: 'Salut',
    fromAgency: 'de {agency}',
    notUser: 'Pas {name}?',
    introOnline:
      "Entraînez-vous immédiatement en ligne ou préchargez le contenu afin qu'il soit toujours disponible pour une utilisation hors ligne !",
    introOffline: 'Vous avez déjà la dernière version préchargée.',
    startTraining: 'Commencez par la formation',
    downloader: {
      preload: 'Précharger',
      stop: 'Arrêter',
      init: 'Initialiser...',
      lastUpdate: 'Dernière mise à jour:',
    },
  },
  trainingScreens: {
    completedBase: 'Félicitations, vous êtes un spécialiste certifié du Canada.',
    unlock: 'Déverrouillez ce chapitre en terminant le chapitre {number} de la formation.',
    skip: 'Revenir >',
    review: 'Revoir >',
    viewAllTitle: '« Conseil de formation »',
    viewAll:
      "« Afin de passer à la page suivante, veuillez cliquer sur les icônes pour afficher le contenu supplémentaire. Des vidéos, des cartes et d'autres informations utiles ont été fournies pour améliorer votre formation et vous assurer d'atteindre le statut PRO.",
    start: 'Commencer',
    continue: 'Continuer',
    welcome:
      'Bienvenue dans notre section Formation. Complétez des modules pour gagner des points et atteindre l’objectif ultime en devenant un.e spécialiste du Canada Or ! Suivez votre progression sur la barre située à droite de l’écran !',
    restart: 'Redémarrer',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Compléter',
    unlock: 'Déverrouiller ce chapitre en complétant le chapitre de formation {number}.',
    unlockSubtitle: 'Déverrouiller plus de chapitres en complétant les chapitres de formation.',
    unlockFoundation: 'Déverrouillez ce chapitre en complétant les chapitres de la Fondation.',
    allUnlocked: 'Vous avez déverrouillé tous les chapitres !',
    certificate: 'Certificat',
    courseComplete: 'Cours achevé !',
    chapterComplete: 'Chapter complete!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    endReached: 'Vous avez atteint la fin',
    retainEnd:
      "Utilisez la barre supérieure pour naviguer ce chapitre ou appuyez sur le bouton retour pour revenir à la vue d'ensemble.",
    watchListenRead: 'Regarder, écouter et lire plus',
    trouble:
      'Il semble que vous ayez des problèmes, veuillez relire le contenu de la ou des pages précédentes et réessayer.',
    confirm: 'Confirmer votre réponse',
    choose: 'Veuillez choisir une réponse',
    chapter: 'Chapitre',
    essential: 'Modules essentiels',
    essentialSub: 'Complétez ces modules pour obtenir votre statut spécialiste du Canada Bronze',
    specialization: 'Modules de spécialisation',
    specializationSub: 'Complétez ces modules pour obtenir le statut Silver spécialistes du Canada',
    status: 'Votre progression',
  },
  nav: {
    home: 'Accueil',
    train: 'Formation',
    retain: 'Découvrir',
    achievements: 'Réussites',
    directory: 'Agenda',
    promote: 'Promouvoir',
    sell: 'Boîte à outils',
    rewards: 'Récompenses',
    info: 'Info',
    media: 'Média',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Bulletin',
    accountSettings: 'Paramètres du compte',
    messages: 'Message',
    search: 'Rechercher',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Nos modules de formation',
    retain: 'Conserver',
    subapps: 'Mini modules de nos destinations partenaires',
    maintrainings: 'La Fondation',
    subtrainings: "L'Expérience",
  },
  pageDescriptions: {
    train: 'Apprenez, participez et devenez expert',
    showroom: '',
    retain:
      "Votre ressource incontournable pour conserver vos connaissances d'expert et permettre vos efforts de vente. Utilisez cette zone pour répondre de manière experte à une question sur un produit ou même comme présentation de vente impromptue - à tout moment, n'importe où et depuis n'importe quel appareil.",
    promote: 'Démarrez la conversation avec vos clients et prospects.',
    sell: 'Répondez aux questions des clients et concluez la vente.',
    favorites: 'Découvrez votre contenu personnel favori',
    search: 'Rechercher dans tout le contenu',
    subapps:
      'Améliorez votre niveau de connaissance et gagnez un badge pour CHAQUE chapitre de province, territoire ou ville que vous terminez. Terminez 10 des 29 chapitres au total et obtenez le statut OR. Complétez 22 des 29 chapitres au total et atteignez le plus haut statut de spécialiste, PLATINE !',
    maintrainings: 'Terminez les modules de base pour obtenir votre diplôme.',
    subtrainings: 'Plongez dans les nombreuses expériences distinctives du Canada et obtenez le statut Argent',
  },
  general: {
    forgot: 'Mot de passe oublié?',
    register: "S'inscrire",
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    logIn: 'Se Connecter',
    logOut: 'Se déconnecter',
    viewItem: 'Visualiser',
    showcase: 'Showcases',
    imageNotFound: 'Image non trouvée',
    noResultsFor: "Aucun résultat n'a été trouvé pour :",
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez pas encore reçu de messages !",
    resultsFor: 'Des résultats pour :',
    showAll: 'Afficher tout',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 Page non trouvée !',
    oops: 'Euh oh...',
    overview: "Retour à l'aperçu",
    complete: 'Cours achevé !',
    share: 'Partager',
    destinations: 'Mini formation de partenaire de la Canada',
    essentials: 'Les essentiels de la Canada',
    trainingLibrary: 'Bibliothèque de formation',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    courseComplete: 'Cours achevé !',
    chapterComplete: 'Chapter complete!',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site Web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faire tourner les cadrans pour faire correspondre à la réponse',
    fitb: 'Remplir les espaces vides',
    flip: 'Changer le numéro pour correspondre à la réponse',
    multipleChoice: 'Choisir la (les) bonne (s) réponse (s)',
    slider: "Choisir la bonne réponse à l'aide du curseur",
    map: 'Répondre à la question en appuyant sur le bon emplacement sur la carte',
    dropdown: 'Choisir...',
    true: 'Vrai',
    false: 'Faux',
  },
  cookies: {
    consent: 'ACCEPTER',
    optout: 'Se désengager',
    settings: 'Paramètres de confidentialité ',
    message:
      'Vous ne nous avez rien communiqué à propos de vos préférences en matière de confidentialité des données !',
    disabled: "Il semble que vous ayez désactivé l'utilisation des cookies.",
    use: "Le {Nom de l’app} exige l'utilisation de cookies pour vous offrir la meilleure expérience.",
    details: 'À quoi servent les cookies ?',
    enable: 'Voir comment activer vos cookies {ici}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connecté",
    title: 'Vous devez être connecté pour visualiser ce contenu',
    guest: 'L’invité',
  },
  demo: {
    message: 'Ce site Web est une démonstration du produit final.',
    consent: '',
  },
  share: {
    header: '',
    download: 'download',
  },
  sharing: {
    email: 'Courriel',
    facebook: 'Facebook',
    twitter: 'Twitter',
    download: 'Télécharger',
    print: 'Imprimer',
    copy: 'Copier le lien',
    copyURL: 'Copier le lien',
    copied: 'Copié',
    shareSubjectDiploma: 'Mon Diplôme du Programme Spécialiste du Canada',
    shareSubjectBadge: 'Mon Insigne du Programme Spécialiste du Canada',
    shareBodyDiploma:
      "Je suis ravi(e) de partager que je suis maintenant un Spécialiste Certifié du Canada ! Cela signifie que j'ai l'expertise et l'accès privilégié pour vous aider à planifier les meilleures vacances possibles. Veuillez me contacter lorsque vous serez prêt(e) à commencer la planification.",
    shareBodyBadge:
      'Je voulais vous informer que je suis maintenant un spécialiste certifié en {chapterTitle}, et je suis heureux/heureuse de répondre à vos questions et de vous aider à planifier votre prochain voyage incroyable. Faites-moi savoir quand vous êtes prêt(e) à partir !',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "Il semble que vous essayez d'accéder à {appName} à partir d'un appareil mobile.",
    body: "Pour télécharger ce programme, visitez tout simplement l’app store et recherchez {appName} ou cliquez sur l'un des boutons ci-dessous",
    benefits: {
      header: 'Cela vous fournira :',
      1: 'La portabilité',
      2: 'Pas besoin de WiFi, entraînez-vous quand et où il vous convient',
      3: 'Des outils et des ressources de vente à votre portée',
    },
  },
  newTrainingFlow: {
    tip: 'Vous obtenez votre statut en complétant les modules de chaque niveau.  Rêvez en grand et obtenez le statut Gold CA spécialistes du Canada by completing aen complétant tous les modules !',
    essentialModules: 'Chapitres Essentiels',
    finishBronze: 'Complétez ces modules essentiels pour obtenir le statut BRONZE et passez à la section suivante.',
    specializationModules: 'Modules de spécialisation',
    finishSilver:
      'Explorez les incroyables activités et aventures du Canada pour atteindre le statut ARGENT et recevoir votre diplôme !',
    partnerModules: 'Modules partenaires',
    finishGold:
      'Améliorez votre niveau de connaissance et gagnez un badge pour CHAQUE chapitre de province, territoire ou ville que vous terminez. Terminez 10 des 29 chapitres au total et obtenez le statut OR. Complétez 22 des 29 chapitres au total et atteignez le plus haut statut de spécialiste, PLATINE !',
    currentStatus: 'Situation actuelle',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'jusqu’à ce que vous ayez atteint le {rank} classement !',
    outOf: 'de {points}  XP sur les',
    pointsToRank: '{pointsToLevel} XP devrait se classer :  ({rank})',
  },
  popUp: {
    congratulations: 'CONGRATULATIONS!',
    bronze:
      "Bon travail! Vous avez tout appris sur l'essentiel du Canada et avez obtenu le statut BRONZE. Ensuite, nous explorerons les nombreux types d'expériences que les visiteurs peuvent vivre ici.",
    silver:
      "Toutes nos félicitations! Vous avez obtenu votre diplôme de spécialiste certifié du Canada en réussissant tous les modules de The Foundation et The Experience. Votre diplôme est consultable et téléchargeable à tout moment depuis le haut de votre tableau de bord Apprentissage. Vous avez également atteint le statut ARGENT et êtes prêt à viser l'OR et au-delà en procédant à la section Provinces, territoires et villes ci-dessous. Continuez ce bon travail!",
    gold: "Bon travail! Vous avez terminé avec succès 10 modules Provinces, Territoires & Villes et avez maintenant obtenu le statut GOLD. Choisissez d'en compléter 12 autres et vous deviendrez un spécialiste canadien de niveau PLATINE à part entière !",
    platinum:
      'Toutes nos félicitations!! Vous avez obtenu le statut PLATINE - le plus haut niveau de qualification en tant que spécialiste certifié du Canada. Merci pour tout votre travail acharné et votre partenariat dans la vente du Canada.',
    platinumWithLink: {
      start:
        'You have just achieved PLATINUM status as a Canada Specialist. You are truly at the top of the class now, well done! You have earned some rewards for your hard work. Click',
      end: 'to visit your Achievements Dashboard and learn how to redeem exclusive PLATINUM deals and offers from our partners.',
      link: 'HERE',
    },
  },
  points: {
    completed: '{completed} / {total} complété',
  },
  rewards: {
    profile: 'Votre Profil',
    rewards: 'Récompenses',
    title: 'Bienvenue au Centre de Récompenses',
    subheader: 'Suivez et partagez vos réservations et vos récompenses',
    subTitle:
      'Nous vous offrons la chance de gagner des récompenses en devenant spécialiste grâce à notre programme, et en réservant un voyage au Canada !',
    body: 'Réservez un voyage au Canada pour tenter de gagner ! Saisissez vos réservations pour être éligible à une carte-cadeau électronique d’incitation de 5 $ US/CAN.',
    item1:
      'Après votre première réservation confirmée de 4 nuits ou plus (réservation individuelle), pour un minimum de deux (2) passagers, dans un hôtel ou complexe admissible. (Les croisières ne sont pas admissibles.)',
    item2: 'Offre valable après avoir complété les modules essentiels du Programme Spécialiste Canada.',
    link1: 'Avez-vous réservé le Canada ?',
    link2: 'Si oui, soumettez votre réservation ici.',
    button: 'Soumettre votre réservation',
    products: 'Marché',
    viewAllBookings: 'Tableau de bord des Réservations',
    viewLeaderboard: 'Classement',
    viewDashboard: 'Tableau de bord des Réalisations',
    viewRewards: 'Accueil des Récompenses',
    form: 'SOUMETTRE UNE RÉSERVATION',
    menu: {
      home: 'Centre\nde Récompenses',
      achievements: 'Réalisations\nde Formation',
      bookings: 'Tableau de bord\ndes Réservations',
      form: 'Soumettre\nRéservations',
    },
    overview: {
      title: 'Bienvenue au Centre de Récompenses du Programme Spécialiste Canada.',
      subtitle: 'Utilisez cette section pour suivre vos progrès de formation, réalisations et récompenses.',
      description: "Voici comment :",
      dashboard: {
        title: 'Tableau de Bord des Réalisations',
        description:
          'Suivez vos progrès de formation, diplômes, et badges via le tableau de bord des réalisations. En gravissant les échelons du Bronze au Platine, vous verrez votre statut évoluer.',
        bronze: 'Le statut BRONZE est obtenu après avoir terminé les chapitres de base',
        silver: 'Le statut ARGENT est obtenu, avec votre diplôme, après avoir terminé les chapitres Expérience',
        gold: 'Le statut OR est obtenu après avoir terminé 10 chapitres sur les Provinces/Territoires/Villes',
        platinum: 'Le statut PLATINE est obtenu après avoir terminé 22 chapitres sur les Provinces/Territoires/Villes',
      },
      platinumRewards: {
        title: 'Récompenses Platine',
        description:
          "Les spécialistes Canada de niveau Platine reçoivent des récompenses spéciales telles que des Pass Expérience Destination de nos partenaires. Une fois votre badge Platine obtenu, vous recevrez une liste des Pass disponibles et les instructions pour les utiliser. L'utilisation nécessite de télécharger votre badge Platine pour vérification.",
      },
      downloads: {
        title: 'Téléchargements',
        description:
          'Le tableau de bord vous permet de consulter et de télécharger votre diplôme de Spécialiste Canada, vos badges de provinces/territoires/villes, ainsi que vos badges de statut métallique. Cliquez simplement sur l’icône pour enregistrer et partager avec vos clients.',
      },
      termsNotice: {
        start: 'Voir les conditions',
        end: 'pour plus de détails.',
        link: ' Termes et Conditions ',
      },
      rewards: {
        title: 'Récompenses',
        description: {
          start: 'Les spécialistes Canada de niveau Platine reçoivent des récompenses spéciales telles que',
          end: "de nos partenaires. Une fois le badge Platine obtenu, vous recevrez une liste des Pass disponibles et les instructions pour les utiliser.",
          bold: 'Pass Expérience Destination',
        },
      },
    },
    home: {
      entries: 'Participations en cours',
      trainingAchievements: 'RÉALISATIONS DE FORMATION',
      trainingAchievementsText:
        'Suivez vos progrès, certifications, et statuts métalliques ici. Vous pourrez aussi télécharger et partager votre diplôme ainsi que vos badges.',
      bookingDashboard: 'TABLEAU DE BORD DES RÉSERVATIONS',
      bookingDashboardText: 'Suivez et gérez facilement vos réservations depuis ce tableau.',
      submitBooking: 'SOUMETTRE DES RÉSERVATIONS',
      submitBookingText: 'C’est ici que vous soumettez vos réservations pour les concours.',
      currentContest: 'CONCOURS ACTUEL',
      currentContests: 'CONCOURS ACTUELS',
      contestHeader: 'Gagnez des prix en espèces chaque mois !',
      contestPrizes:
        'Soumettez vos réservations d’hôtel, services terrestres et location de voiture chaque mois pour tenter de gagner trois grands prix :',
      contestPrize1: 'Une (1) carte-cadeau de 250 $',
      contestPrize1Description: ' sera attribuée au conseiller ayant le plus de réservations ce mois-ci*',
      contestPrize2: 'Deux (2) cartes-cadeaux de 100 $',
      contestPrize2Description: ' seront attribuées à deux conseillers tirés au sort',
      contestConditions: '*Une (1) participation sera attribuée pour chaque réservation admissible :',
      contestLodging: 'Hébergement : ',
      contestCondition1: 'Réservations de 3 nuits ou plus',
      contestGroundServices: 'Services terrestres :  ',
      contestCondition2: '3 services ou plus (ex : accueil, transfert, visites)',
      contestCarRental: 'Location de voiture : ',
      contestCondition3: 'au moins 3 jours',
      contestStartEarning: 'Commencez à accumuler vos chances de gagner en ',
      contestEnterBookings: 'soumettant vos réservations',
      contestNow: ' maintenant !',
      contestSeeOther: 'Voir les autres ',
      contestTerms: 'Termes et Conditions',
    },
    bookingRewardsView: {
      title: 'Marché',
    },
    bookingsView: {
      rowsPerPage: 'Lignes par page',
      rangeSeparator: 'sur',
      selectAllRowsItem: 'tout',
      title: 'Tableau de bord des Réservations',
      subtitle: 'Suivez et gérez vos réservations ici.',
      manage: 'Gérer les Réservations',
      manageSub:
        'Triez avec les boutons ci-dessus et cliquez sur un enregistrement pour gérer les détails. Les entrées en attente seront vérifiées sous 72 heures.',
      noBookings: 'Aucun enregistrement à afficher.',
      statusCategories: {
        confirmedentries: "Entrées Approuvées",
        pendingentries: "Entrées en Attente",
        rejectedentries: "Entrées Refusées",
        viewall: "Tout Voir"
      },
      columns: {
        reservationNumber: "Numéro de réservation",
        status: "Statut",
        firstName: "Prénom",
        numberOfGuests: "Nombre de voyageurs",
        lengthOfStay: "Durée du séjour",
      }
    },
    leaderboardScreen: {
      title: 'CLASSEMENT\nDES POINTS LC',
      earnedpts: 'MES POINTS LC GAGNÉS :',
      pointsWall: 'SUIVI DES 5 MEILLEURS :',
      startEarning: "Commencez à gagner des XP et entrez dans le classement !",
      prizes: 'Prix',
      tAndC: 'Conditions générales applicables*',
      pointsOverview: {
        title: 'Comment gagner des points',
        booths: 'Visitez les vitrines des exposants',
        breakoutSessions: 'Participez aux ateliers & présentations',
        trainingSessions: 'Terminez un chapitre de formation',
        adventureSpotlights: 'Conseils pour les voyages en famille',
        share: 'Partage de contenu',
        shareMax: '(jusqu’à {maxSharePoints} points)',
        shareInfo:
          'Le partage est comptabilisé en partageant le contenu sur Twitter, Facebook ou avec des collègues/clients.',
        viewVideo: 'Voir la vidéo',
      },
    },
    dashboardView: {
      title: 'Tableau de bord de vos gains',
    },
    bookingForm: {
      title: 'Formulaire de Soumission de Réservation',
      subTitle: 'Saisissez votre réservation :',
      required: '* Champ requis',
      email: 'Email du conseiller',
      agentFirstName: 'Prénom du conseiller',
      agentLastName: 'Nom du conseiller',
      company: 'Nom de l’agence / entreprise',
      iata: 'Numéro IATA/CLIA',
      stateProvince: 'État / Province',
      postalCode: 'Code postal',
      country: 'Pays',
      city: 'Ville',
      birthday: 'Date de naissance',
      type: 'Type de voyage du client',
      source: 'Source de réservation',
      select: 'Veuillez sélectionner une option',
      tourOperator: 'Tour-opérateur',
      provinceVisited: 'Province ou Territoire Visité',
      firstName: 'Prénom du client',
      lastName: 'Nom du client',
      bookingNumber: 'Numéro de confirmation',
      file: 'Téléchargement de la preuve RezSnap™',
      arrivalDate: 'Date d’arrivée',
      pax: 'Pax',
      departureDate: 'Date de départ',
      brand: 'Marque LC réservée',
      lengthOfStay: 'Durée du séjour (en nuits)',
      cost: 'Coût total de la réservation',
      rooms: 'Nombre de chambres',
      stay: 'Durée du séjour (en nuits)',
      airline: 'Compagnie aérienne (code à 2 lettres)',
      gateway: 'Aéroport d’origine (code à 3 lettres)',
      destination: 'Destination / île (code à 3 lettres)',
      disclaimer: '* Champs requis',
      button: 'Soumettre votre réservation',
      sub: 'Vos informations',
      sub2: 'Informations sur la réservation',
      editInfo: "Modifier vos informations",
      dropzone: "Glissez-déposez un fichier ici ou cliquez pour en sélectionner un.",
      dropzoneAcceptedFiles: "Un fichier accepté (.jpeg, .png, .pdf). Taille max : 100 Mo.",
    },
    TermsAndConditions: {
      title: 'Termes et Conditions',
      subTitle: 'Récompenses Trimestrielles du Spécialiste Canada',
      body1:
        'Chaque soumission doit être accompagnée d’un justificatif de vente à solde nul correspondant. Les gagnants seront choisis selon les documents vérifiés. Les récompenses ne sont pas transférables et doivent être utilisées dans les 3 mois. Les récompenses non réclamées seront perdues.',
      body2:
        'Pour être éligible, vous devez résider aux É.-U. ou au Canada et être majeur dans votre région. Les employés de tour-opérateurs et les résidents du Québec ne sont pas admissibles.',
      body3:
        'Une preuve d’accréditation peut être exigée. Les récompenses sont susceptibles d’être modifiées durant le programme.',
      body4: 'Vie Privée et Utilisation des Données',
      body5:
        'Les participants autorisent l’utilisation de leurs coordonnées pour contacter et annoncer les gagnants, à des fins promotionnelles, et pour transmission à des prestataires tiers.',
      button: 'Retour à l’accueil',
    },
    thankYouPage: {
      thanks: 'Merci',
      congrats: 'Félicitations, ',
      body: 'votre réservation a été reçue et transmise au superviseur pour vérification.',
      link: 'Veuillez noter que pour être gagnant, vous devez avoir complété les modules essentiels du Programme Spécialiste Canada',
    },
    bookingTable: {
      points: "Points",
      status: "Statut",
      firstName: "Prénom",
      lastName: "Nom de famille",
      bookingDate: "Date de réservation",
      rooms: "Chambres",
      cost: "Coût",
    },
  },
  badgeView: {
    title: 'Tableau de bord des réalisations',
    subtitle:
      'Bienvenue sur votre tableau de bord des réalisations, où vous pouvez voir, suivre et télécharger vos diplômes et vos badges de spécialisation',
    viewBadge: 'Voir le statut',
    badgeDisplayTitle: "Statut d'Accomplissement",
    badgeAchievement:
      "Vous avez atteint le statut {rank} ! Cliquez sur l'icône à droite pour afficher et partager votre statut",
    badgesCompleteTitle: 'Vos badges de spécialisation',
    badgesCompleteSubtitle: 'Cliquez sur les icônes pour afficher, enregistrer et partager vos badges',
    badgesIncompleteSubtitle: 'Gagnez plus de badges en terminant ces chapitres',
    bronze: 'Bronze',
    silver: 'Argent',
    gold: 'Or',
    platinum: 'Platinum',
    complete: 'Complété',
    diploma: 'Diplôme',
    badgeAchievementWithRewards: {
      start: 'Félicitations ! Vous avez atteint le statut de Platine. Cliquez sur ',
      link: 'ici',
      end: ' pour accéder à votre récompense de statut Platine.',
    },
  },
};
